import { CircleAlert, CircleCheck, Info, X } from "lucide-react";

import { useToast } from "@/state/toast";
import { cn } from "@/lib/utils";

const icons = { info: Info, success: CircleCheck, error: CircleAlert } as const;

export function Toaster() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div aria-live="polite" className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[min(360px,calc(100vw-2rem))] flex-col gap-2">
      {toasts.map((t) => {
        const Icon = icons[t.tone];
        return (
          <div
            className={cn(
              "pointer-events-auto flex items-start gap-3 rounded-xl border bg-white px-4 py-3 text-sm shadow-lg dark:bg-[#202629]",
              t.tone === "error" ? "border-[#ffb4b4] dark:border-[#5a2a2a]" : "border-[#dfe3eb] dark:border-[#3f4548]",
            )}
            key={t.id}
            role="status"
          >
            <Icon
              className={cn(
                "mt-0.5 h-4 w-4 shrink-0",
                t.tone === "success" && "text-[#16b978]",
                t.tone === "error" && "text-[#ff3434]",
                t.tone === "info" && "text-[#4077f6]",
              )}
            />
            <p className="flex-1">{t.message}</p>
            <button aria-label="Cerrar" className="text-[#8190b0] hover:text-[#1f2433] dark:hover:text-white" onClick={() => dismiss(t.id)} type="button">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
